// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import LegacyLink from '../../Common/LegacyLink';
import Zendesk from '../../Common/ZendeskLink';

type PrimaryLinksProps = {
  showSearchLink: boolean,
  hideFindParking: boolean,
  hideCPM: boolean
};

export const PrimaryLinks = ({
  showSearchLink,
  hideFindParking,
  hideCPM
}: PrimaryLinksProps) => {
  return (
    <>
      {!hideFindParking && (
        <li className="mobile-hidden">
          <Link to="/">Find parking</Link>
        </li>
      )}
      {showSearchLink && [
        <li className="mobile-hidden">
          <Link to="/">Search</Link>
        </li>
      ]}
      <li className="mobile-hidden">
        <LegacyLink to="about/">About</LegacyLink>
      </li>
      <li className="mobile-hidden">
        <LegacyLink to="about/rent-your-space/">
          Rent out your driveway
        </LegacyLink>
      </li>
      {!hideCPM && (
        <li className="mobile-hidden">
          <LegacyLink to="car-park-management/">Car park management</LegacyLink>
        </li>
      )}
    </>
  );
};

type PrimaryNavProps = {
  showSearchLink: boolean,
  hideFindParking: boolean,
  hideCPM: boolean,
  isStatic?: boolean,
  renderPrimaryLinks: boolean,
  openHelpInNewTab: boolean
};

const PrimaryNav = ({
  showSearchLink,
  isStatic = false,
  renderPrimaryLinks,
  hideFindParking,
  hideCPM,
  openHelpInNewTab
}: PrimaryNavProps) => (
  <ul className="c-header__menu">
    {!renderPrimaryLinks && (
      <PrimaryLinks
        showSearchLink={showSearchLink}
        hideFindParking={hideFindParking}
        hideCPM={hideCPM}
      />
    )}
    <li className="mobile-hidden">
      <Zendesk openInNewTab={openHelpInNewTab} isStatic={isStatic}>
        Help
      </Zendesk>
    </li>
  </ul>
);

export default PrimaryNav;
